// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-spdm-red[data-v-35bcf625]{color:#ba052a}.c-spdm-white[data-v-35bcf625]{color:#fff}#page_error img[data-v-35bcf625]{margin:40px auto;max-width:400px;width:60%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
